import { render } from "./specialcourse.vue?vue&type=template&id=d66acf02&scoped=true&ts=true"
import script from "./specialcourse.vue?vue&type=script&lang=ts"
export * from "./specialcourse.vue?vue&type=script&lang=ts"

import "./specialcourse.vue?vue&type=style&index=0&id=d66acf02&lang=less&scoped=true"

import exportComponent from "E:\\operationmanualNew\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d66acf02"]])

export default __exports__